import { render, staticRenderFns } from "./EstadoBus.vue?vue&type=template&id=13951f22"
import script from "./EstadoBus.vue?vue&type=script&lang=js"
export * from "./EstadoBus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports